import styled from 'styled-components'
import { Form } from 'formik'
import { Button } from '../../../ui/button'
import { Text1 } from '../../../ui/text'
import {
	FixedBottomButtonContainer,
	ScreenContainer as BaseScreenContainer,
	BackButton as BaseBackButton
} from '../styled'

export const Container = styled(BaseScreenContainer).attrs({
	$fullHeight: true,
	$mobilePadding: '40px 10px 10px 20px'
})`
display: flex;
	flex-direction: column;
	gap:16px;
`



export const TopInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`

export const StyledForm = styled(Form)`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`

export const TextAreaContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`

export const Comments = styled.textarea`
	padding: 8px;
	resize: none;
	border-radius: 4px;
	border: 1px solid ${props => props.theme.colors.greys.disabledGrey};
	background: ${({ theme }) => theme.colors.brand.white};
	outline-color: ${({ theme }) => theme.colors.brand.blueOmint};
	font-size: 14px;
	min-height: 80px;
	::placeholder {
		color: ${props => props.theme.colors.text.secondaryText};
	}
`

export const TextWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`

export const NextButton = styled(Button)`
	align-self: flex-start;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		align-self: center;
		width: 100%;
		max-width: 100%;
	}
`

export const NextButtonContainer = FixedBottomButtonContainer

export const BackButton = styled(BaseBackButton).attrs({
	$marginBottom: '8px',
	$mobileMarginBottom: '0'
})`
	gap: 8px;
`
